import { motion } from "framer-motion";
import { KeyRound, EyeOff, Ban } from "lucide-react";
import { SectionHead } from "./Features";

// Posicionales: el orden debe seguir a t.security.items.
const icons = [KeyRound, EyeOff, Ban];

export const Security = ({ t }) => (
  <section id="security" data-testid="security-section" className="py-24 md:py-32 bg-[#0A0A0A] border-y border-white/5">
    <div className="max-w-7xl mx-auto px-6 lg:px-8">
      <SectionHead kicker={t.security.kicker} title={t.security.title} subtitle={t.security.subtitle} />
      <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
        {t.security.items.map((item, i) => {
          const Icon = icons[i];
          return (
            <motion.div
              key={item.title}
              data-testid={`security-card-${i}`}
              initial={{ opacity: 0, y: 24 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-80px" }}
              transition={{ delay: i * 0.1, duration: 0.5 }}
              className="bg-[#0F0F0F] border border-white/10 hover:border-orange-500/50 rounded-2xl p-8 transition-colors duration-300"
            >
              <Icon className="w-6 h-6 text-[#FFC000] mb-6" />
              <h3 className="font-heading text-lg font-medium text-white mb-3">{item.title}</h3>
              <p className="text-sm text-zinc-400 leading-relaxed">{item.desc}</p>
            </motion.div>
          );
        })}
      </div>
    </div>
  </section>
);
